var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"click":_vm.click}),(_vm.isAddingToCart)?_c('re-loading',{attrs:{"loadingMessage":"Your order is being processed..."}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }